// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__149P6","signatureBlock":"Footer_signatureBlock__3wm44","signature":"Footer_signature__1TIAr"};